import { render, staticRenderFns } from "./ClassifiedCard.vue?vue&type=template&id=482860d4&scoped=true&lang=pug"
import script from "./ClassifiedCard.vue?vue&type=script&lang=js"
export * from "./ClassifiedCard.vue?vue&type=script&lang=js"
import style0 from "./ClassifiedCard.vue?vue&type=style&index=0&id=482860d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482860d4",
  null
  
)

export default component.exports